module.exports = __webpack_public_path__ + "5c32974286ff67d7d6c869be1e3015b2.jpg";